/**
 * author:@varun
 */
//TODO: Remove the hardcoded values after the test data is removed and replace it with provider.

angular.module('App.video.urls', ['jv.Common.Jobvite.Urls','jv.Common.browser.details'])
.factory('videoServiceConstant', ['$jobviteUrls',
    function($jobviteUrls) {
        return {
            Urls: {
                'list': $jobviteUrls.video + '/action/user/video/list', //GET
                'questionDetails': $jobviteUrls.video + '/action/user/video/question/{0}', //GET
                'question': $jobviteUrls.video + '/action/user/video/question/{0}/title', //GET
                'answer': $jobviteUrls.video + '/action/user/video/answer/{0}', //GET, PUT, POST
                'summary': $jobviteUrls.video + '/action/user/video/summary/{0}', //GET
                'answerSummary': $jobviteUrls.video + '/action/user/video/{0}', //GET
                'remainingTime': $jobviteUrls.video + '/action/user/video/question/{0}/time', //GET
                'companyDescription': $jobviteUrls.jhire + '/action/admin/company/{0}/description',
                'practice': $jobviteUrls.video + '/action/user/video/practice',
                'reqExtension': $jobviteUrls.video + '/action/user/video/{0}/message',
                'vonageSessionId': $jobviteUrls.video + '/action/user/video/session',
                'vonageStartArchive': $jobviteUrls.video + '/action/user/video/archive/start/{0}/{1}/{2}',
                'vonageStopArchive': $jobviteUrls.video + '/action/user/video/archive/stop/{0}/{1}',
                'isVonageEnabled': $jobviteUrls.video + '/action/user/video/getVonageStatus'
            }
        };
    }
]);


angular.module('App.video.service', ['App.video.urls', 'App.ajax.service'])
    .service('formResponseIdService', function() {
        var _id = null;
        var service = {
            setId: function(id) {
                _id = id;
            },
            getId: function() {
                return _id;
            }
        };
        return service;
    }).service('dataService', function() {
        var id = null;
        //VA: refresh on the flash detection page was taking the jobseeker to the first question. Any time the jobseeker refreshes the page. We must check for the browser feature detections.
        // sysTest tracks whether the user is currently running the system test
        var sysTest = true;
        var vonageTestStatus = 'pending';
        var service = {
            setActualId: function(actualId) {
                id = actualId;
            },
            getActualId: function() {
                return id;
            },
            setSystemTest: function(systemTest) {
                sysTest = systemTest;
            },
            getSystemTest: function() {
                return sysTest;
            },
            // for vonage system test storage
            getSystemTestStatus: function() {
                return vonageTestStatus;
            },
            setSystemTestStatus: function(status) {
                vonageTestStatus = status;
            },
            setSessionData: function(key, value){
                window.sessionStorage.setItem(key, value);
            },
            getSessionData: function(key){
                return window.sessionStorage.getItem(key);
            },
            removeSessionData: function(key){
                window.sessionStorage.removeItem(key);
            },
            checkNetwrokConnection: function(){
                return navigator.onLine;
            }
        };
        return service;
    }).service('videoService', ['videoServiceConstant', 'makeAjaxCall', 'formResponseIdService', 'browserDetails', '$q',
        function(videoServiceConstant, makeAjaxCall, formResponseIdService, browserDetails, $q) {
            var videoService = {};

            /**
             *  Utility for calling the ajax functions. s
             */
            function createRequestObject(args, callback, options) {
                callback = (callback || angular.noop);
                var requestObj = args || {};
                requestObj.ajaxtype = options.ajaxtype;
                requestObj.url = options.url;
                requestObj.requestType = options.requestType || 'GET';
                requestObj.cache = options.cache || false;
                var requestPromise = makeAjaxCall(requestObj);
                requestPromise.then(function(results) {
                    callback(results.data);
                });

            }

            // Get the list of videos.
            videoService.getList = function(args, callback) {
                var options = {
                    'ajaxtype': 'getVideoListForJobseeker',
                    'url': videoServiceConstant.Urls.list,
                    'cache': true
                };
                createRequestObject(args, callback, options);
            };

            //After the video interview is done make this api call to get the summary of ther interview taken by the interviewee.
            videoService.getAnswerSummary = function(args, callback) {
                var options = {
                    'ajaxtype': 'getIntervieweeVideoAnswersSummary',
                    'url': videoServiceConstant.Urls.answerSummary.format(formResponseIdService.getId())
                };
                createRequestObject(args, callback, options);
            };

            // Get the next question details, this service doesnt get the actual question from the backend.
            videoService.getQuestionDetails = function(args, callback) {
                var options = {
                    'ajaxtype': 'getIntervieweeVideoQuestionDetails',
                    'url': videoServiceConstant.Urls.questionDetails.format(formResponseIdService.getId())
                };
                createRequestObject(args, callback, options);
            };

            //Ajax call to get Vonage session ID
            videoService.getVonageSessionId = function(args, callback) {
                var options = {
                    'ajaxtype': 'getVonageSessionId',
                    'url': videoServiceConstant.Urls.vonageSessionId,
                    'requestType': 'POST'
                };
                createRequestObject(args, callback, options);
            };

            //Ajax call to startVonageArchive
            videoService.startVonageArchive = function(args, callback) {
                var options = {
                    'ajaxtype': 'getVonageStartArchive',
                    'url': videoServiceConstant.Urls.vonageStartArchive.format(formResponseIdService.getId(),args.sessionId,args.name),
                    'requestType': 'POST'
                };
                createRequestObject(args, callback, options);
            };

            //Ajax call to stop Vonage Archive
            videoService.stopVonageArchive = function(args, callback) {
                var options = {
                    'ajaxtype': 'getVonageStopArchive',
                    'url': videoServiceConstant.Urls.vonageStopArchive.format(formResponseIdService.getId(),args.archiveId),
                    'requestType': 'POST'
                };
                createRequestObject(args, callback, options);
            };

            //Ajax call to check Vonage or flash
            videoService.isVonageEnabled = function(args, callback) {
                var expectedJson = {'isVonage':true};
                callback(expectedJson);
            };

            // Get the question, it gets the question for the getQuestionDetails API.
            videoService.getQuestion = function(args, callback) {
                var options = {
                    'ajaxtype': 'getIntervieweeVideoQuestion',
                    'url': videoServiceConstant.Urls.question.format(args.id)
                };
                delete args.id;
                createRequestObject(args, callback, options);
            };

            //Send the answer.
            videoService.sendAnswer = function(args, callback) {
                //Varun: TODO: add duration of the video to the backend.
                if (angular.isUndefined(args) || angular.isUndefined(args.vid)) {
                    // We need both of these entries to make the call.
                    return;
                }
                var options = {
                    'ajaxtype': 'submitAnswerOfJobSeeker',
                    'url': videoServiceConstant.Urls.answer.format(formResponseIdService.getId()),
                    'requestType': 'POST'
                };
                createRequestObject(args, callback, options);
            };

            //Get the summary for the video interview
            videoService.getSummary = function(args, callback) {
                var options = {
                    'ajaxtype': 'getVideoInterviewSummary',
                    'url': videoServiceConstant.Urls.summary.format(formResponseIdService.getId()),
                    'cache': true,
                    'requestType': 'POST'
                };

                if (args === null) {
                    args = {};
                }

                args.browser = browserDetails.getBrowser();
                args.browserVersion = browserDetails.getBrowserVersion();
                args.OSVersion = browserDetails.getOSVersion();
                args.flashVersion = browserDetails.getFlashVersion();

                createRequestObject(args, callback, options);
            };


            videoService.getPracticeInterview = function(args, callback) {
                var options = {
                    'ajaxtype': 'getJobseekerPracticeInterviewQuestions',
                    'url': videoServiceConstant.Urls.practice,
                    'cache': true
                };
                createRequestObject(args, callback, options);
            };

            videoService.requestExtension = function(args, callback) {
                if (angular.isUndefined(args) || angular.isUndefined(args.ID)) {
                    return;
                }

                var options = {
                    'ajaxtype': 'requestExtensionJobseeker',
                    'url': videoServiceConstant.Urls.reqExtension.format(args.ID),
                    'requestType': 'POST'
                };

                delete args.ID;

                createRequestObject(args, callback, options);
            };

            videoService.validateDevices = function(){
                var defer = $q.defer();
                var validatedDevices = [];
                window.OT.getDevices(function(err, devices) {
                    angular.forEach(devices, function (value) {
                        value.deviceId && validatedDevices.push(value.kind);
                    });
                    defer.resolve(validatedDevices);
                });
                return defer.promise;
            };
            return videoService;
        }
    ]);
